import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { AppSystemType, Urls } from 'kts-platform-frame/entry/constant';
import ReduxState, { IConfigApp } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Carousel, Badge, Icon } from 'antd';
import { mediaUrl } from 'kts-platform-frame/entry/configUtils';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import { withRouter } from 'kts-platform-frame/routes';
import { Spin } from 'antd';

const css = require('./index.scss');

class UIComponentsState {
    public carousel: Carousel;
}

/** Redux接口 */
interface IReduxStatePart {
    appMap?: Map<string, IConfigApp>;
    currentcompanyId?: string;
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@withRouter
@connect((state: ReduxState): IReduxStatePart => ({
    appMap: state.config.appList.map,
    currentcompanyId: state.user.currentcompanyId,
    loadingUrls: state.system.loadingUrls,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState, UIComponentsState> {

    state = new UIComponentsState();

    /** 公司ID */
    private _currentcompanyId: string;

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentWillMount() {
        ModulesAction.getAppList();
        this.setCurrentcompanyId(this.props.currentcompanyId);
    }

    componentDidUpdate() {
        this.setCurrentcompanyId(this.props.currentcompanyId);
    }

    render() {
        const { appList } = this.modulesState;
        return (
            <div>
                <div className={css.MyApp}>
                    <div className={css.AppConten}>
                        <div className={css.title}>科技推动商业平等链接</div>
                        <p className={css.titleTip}>打造智慧供应链网络</p>
                        {
                            appList.length > 9 &&
                            <Icon className={css.carouselPrev} type="xiala" onClick={this.onPrevHandler} />
                        }
                        {
                            appList.length > 9 &&
                            <Icon className={css.carouselNext} type="xiala" onClick={this.onNextHandler} />
                        }
                        <Carousel ref={e => { this.setState({ carousel: e }); }} className={css.carousel} >
                            {this.buildPage()}
                            {
                                appList.length === 0 && (
                                    this.props.loadingUrls.has(Urls.queryMy)
                                        ? <Spin tip="正在努力为你加载中" />
                                        : <p className={css.dataTip}>暂无数据</p>)
                            }
                        </Carousel>
                    </div>
                </div>
            </div>
        );
    }

    private onPrevHandler = () => {
        this.state.carousel && this.state.carousel.prev();
    }

    private onNextHandler = () => {
        this.state.carousel && this.state.carousel.next();
    }

    /** 设置公司ID */
    private setCurrentcompanyId = (currentcompanyId: string) => {
        if (this._currentcompanyId === currentcompanyId) {
            return;
        }

        this._currentcompanyId = currentcompanyId;
        ModulesAction.getAppList();
    }

    /** 创建app 页面 */
    private buildPage() {
        const { appList } = this.modulesState;
        let htmlArr = [];
        if (!appList.length) {
            return htmlArr;
        }
        let index = Math.ceil(appList.length / 9);
        for (let i = 1; i <= index; i++) {
            let start = i * 9 - 9;
            let end = i * 9 < appList.length ? i * 9 : appList.length;
            htmlArr.push(
                <div className={css.page} key={i}>
                    {this.getItem(start, end)}
                </div>
            );
        }
        return htmlArr;
    }

    /** 获取一页的数据 */
    private getItem(start: number, end: number) {
        const { appList } = this.modulesState;
        let items = [];
        for (let index = start; index < end; index++) {
            items.push(
                this.getTemp(appList[index])
            );
        }
        return items;
    }

    /** 获取每项数据的模板 */
    private getTemp(item: IAppInfo) {
        const imgurl = mediaUrl();
        return (
            <a onClick={this.onClickAppHandler(item)} key={item.appKey}>
                <Badge count={0} offset={[20, 140]} className={css.pageItem} >
                    <div>
                        <div style={{ width: '60px', height: '60px', margin: '0 auto', lineHeight: '60px' }}>
                            {
                                item.appIcon
                                    ? <img src={imgurl + item.appIcon} className={css.itemImg} />
                                    : <Icon type="appstore" style={{ color: '#1296db', fontSize: 60 }} />
                            }
                        </div>
                        <p className={css.appName}>{item.appName}</p>
                        <pre className={css.appDisc}>{item.appCategoryName && item.appCategoryName.replace(/,/g, ' ')}</pre>
                    </div>
                </Badge>
            </a>
        );
    }

    /** 点击了APP */
    private onClickAppHandler = (appInfo: IAppInfo) => () => {
        this.props.history.push(`/workbench/m/${appInfo.appKey}`);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/MyApp/UI.Components.tsx